import useTranslation from 'next-translate/useTranslation';

import { Translate } from '@core/constant';
import { EColor, EFontWeight, ETypographyVariant } from '@core/type';

import { Box } from '../layout';
import { Typography } from '../typography';
import { TypographyProps } from '../typography/interface-typography';

export const LabelVatFree = ({ ...restProps }: TypographyProps) => {
  const { t } = useTranslation(Translate.common.PRODUCT);

  return (
    <Box
      whiteSpace={'nowrap'}
      borderRadius={'10px'}
      padding={'0 15px'}
      backgroundColor={EColor.ACCENT}
    >
      <Typography
        variant={ETypographyVariant.BODY3}
        color={{ commonType: EColor.WHITE, intensity: EColor.R900 }}
        fontWeight={EFontWeight.MEDIUM}
        lineHeight={'22px'}
        {...restProps}
      >
        {t('labels.vatFreeProduct')}
      </Typography>
    </Box>
  );
};
